/*
 * Device network-status helpers.
 *
 * The iOS app (AppStatusReporter.swift `networkType`) always sends a non-empty
 * string — exactly "CONNECTED" (on WiFi) or "NOT CONNECTED" (otherwise). So a
 * truthiness check (`!!network_type`) is ALWAYS true and would mark every
 * device online. Compare the literal value instead.
 */

const CONNECTED = "CONNECTED";

// True only when the device reports the connected sentinel — not merely a
// non-empty string.
export const isDeviceOnline = (networkType) => networkType === CONNECTED;

// Human label for the table/detail. Unknown/missing → em dash so a device that
// never reported reads as unknown rather than "Offline".
export const networkLabel = (networkType) => {
  if (networkType == null || networkType === "") return "—";
  return isDeviceOnline(networkType) ? "Online" : "Offline";
};
